import { BusinessError } from './businessError';

export class NotFoundError extends BusinessError {
    public name = 'NotFoundError';
}
